import OverAllCounter from "./OverAllCounter";
// import OverAllCounter from './OverAllCounter'
import { languageHelper } from "../../../../config/helperFunctions";
import { useEffect, useState } from "react";
import axios from "axios";
import { apiKey } from "../../../../config/config";

function OverAllReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/overall-report`, {
        params: {
          outletId: user?.user?.outlet_id,
          from: startDate,
          to: endDate,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [endDate, startDate, user?.user?.outlet_id]);
  return (
    <main>
      <div className="text-d-bg-text text-3xl text-center my-4">
        {languageHelper("Overall Report")}
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <div className="md:flex block flex-wrap gap-5 ms-4 my-2 items-center justify-center">
        <div>
          <label htmlFor="" className="w-full lg:w-1/3">
            <span className="text-d-bg-text text-sm mb">
              {languageHelper("Start Date")}
            </span>
            <div className="mb-2 pt-0">
              <input
                type="date"
                className="px-2 py-2 text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
          </label>
        </div>
        <div>
          <label htmlFor="" className="w-full lg:w-1/3">
            <span className="text-d-bg-text text-sm mb ">
              {languageHelper("End Date")}
            </span>
            <div className="mb-2 pt-0">
              <input
                type="date"
                className="px-2 py-2  text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </label>
        </div>
      </div>
      {data.map((data) => <OverAllCounter data={data} />)}
    </main>
  );
}

export default OverAllReport;
